import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAuth } from '../context/AuthContext';

const { FiClock, FiLogOut, FiCreditCard } = FiIcons;

function PendingApproval() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-gray-100 p-8 text-center"
      >
        <div className="w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiClock} className="text-amber-600 text-3xl" />
        </div>
        <h2 className="text-xl font-black text-gray-900 mb-2">Account Pending Activation</h2>
        <p className="text-sm text-gray-600 mb-6">
          Thanks for registering{user?.name ? `, ${user.name}` : ''}! Please complete your ₹5,999/year subscription payment to activate your account. You'll get full access to the planner as soon as the payment is successful.
        </p>

        <a
          href="https://payments.pabbly.com/subscribe/6a854b04f5f32d8c870cc5ec/goal-planning-tool"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full h-12 bg-[#19b48d] text-white font-bold rounded-xl shadow-lg shadow-[#19b48d]/20 hover:bg-[#16a085] transition-all flex items-center justify-center space-x-2 mb-3"
        >
          <SafeIcon icon={FiCreditCard} />
          <span>Complete Payment</span>
        </a>

        <button
          onClick={logout}
          className="w-full h-11 text-gray-500 font-medium rounded-xl hover:bg-gray-50 transition-all flex items-center justify-center space-x-2"
        >
          <SafeIcon icon={FiLogOut} className="text-sm" />
          <span>Logout</span>
        </button>
      </motion.div>
    </div>
  );
}

export default PendingApproval;